var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomateBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9167 24.8333C20.6696 24.8333 25.3333 20.1696 25.3333 14.4167C25.3333 8.66371 20.6696 4 14.9167 4C9.16371 4 4.5 8.66371 4.5 14.4167C4.5 20.1696 9.16371 24.8333 14.9167 24.8333ZM14.9167 24.8333V58.1667M14.9167 58.1667C9.16371 58.1667 4.5 62.8304 4.5 68.5833C4.5 74.3362 9.16371 79 14.9167 79C20.6696 79 25.3333 74.3362 25.3333 68.5833C25.3333 62.8304 20.6696 58.1667 14.9167 58.1667ZM69.0833 58.1667V27.75C69.0833 23.0829 69.0833 20.7493 68.175 18.9667C67.3762 17.3987 66.1013 16.1239 64.5333 15.325C62.7508 14.4167 60.4171 14.4167 55.75 14.4167H42M69.0833 58.1667C74.8362 58.1667 79.5 62.8304 79.5 68.5833C79.5 74.3362 74.8362 79 69.0833 79C63.3304 79 58.6667 74.3362 58.6667 68.5833C58.6667 62.8304 63.3304 58.1667 69.0833 58.1667ZM42 14.4167L52.4167 24.8333M42 14.4167L52.4167 4",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomateBlack);
export default __webpack_public_path__ + "static/media/automateBlack.8b76e91a7321ff09f06d9046ff59f796.svg";
export { ForwardRef as ReactComponent };